import { WellframeApi } from 'store/api';

export interface CompletionStat {
  completed: number;
  date: string;
  total: number;
}

export interface PhysicalActivityStat {
  active_goal_steps: number;
  active_steps: number;
  date: string;
  elapsed_seconds: number;
  goal_seconds: number;
  passive_goal_steps: number;
  passive_steps: number;
  steps: number;
}

export interface StatsResponse {
  medication_stats: CompletionStat[];
  physical_activity_stats: PhysicalActivityStat[];
  task_stats: CompletionStat[];
}

export interface GetStatsArgs {
  /** yyyy-MM-dd */
  startDate?: string;
  /** yyyy-MM-dd */
  endDate?: string;
}

export type StatsExportType = 'physical_activity' | 'task' | 'medication';

export interface ExportStatsArgs {
  type: StatsExportType;
  /** yyyy-MM-dd */
  startDate: string;
  /** yyyy-MM-dd */
  endDate: string;
}

export const statsService = WellframeApi.injectEndpoints({
  endpoints: (builder) => ({
    getStats: builder.query<StatsResponse, GetStatsArgs | void>({
      query: (args) => {
        const { startDate, endDate } = (args ?? {}) as GetStatsArgs;
        return {
          url: '/api/v4/stats',
          params: {
            ...(startDate ? { startDate } : {}),
            ...(endDate ? { endDate } : {}),
          },
        };
      },
      providesTags: ['Stats'],
    }),
    exportStats: builder.mutation<Blob, ExportStatsArgs>({
      query: ({ type, startDate, endDate }) => ({
        url: '/api/v4/stats/export',
        method: 'GET',
        params: { type, startDate, endDate },
        responseHandler: (response) => response.blob(),
      }),
    }),
  }),
});

export const { useGetStatsQuery, useExportStatsMutation } = statsService;
